import { ReplicaType } from "types";
import Version1 from "./v1";
import Version2 from "./v2";
import Version3 from "./v3";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "advanced-potion-making-edition-II-prince's-copy",
  alternativeIds: ["advanced-potion-making"],
  name: `Advanced Potion-Making\nEdition II\nPrince's Copy`,
  nameFormatted: {
    primary: "Advanced Potion-Making",
    secondary: "Edition II",
    tertiary: "Prince's Copy",
  },
  origin: "Harry Potter and the Half-Blood Prince",

  sort: {
    preferredIndex: 2,
  },

  category: replicaCategories.harryPotter,

  versions: [Version3, Version2, Version1],
};

export default data;
